<template>
    <div class="modal-container">
        <div class="modal-header">
            <h4 class="modal-title">Add Cost item</h4>
        </div>
        <div class="modal-body">
            <form-wrapper :validator="$v.costLine" class="form-wrapper">
                <div class="item-description">
                    <form-group label="Description">
                        <md-input v-model="costLine.description" :disabled="costLine.type === 'surcharge'" />
                    </form-group>
                </div>
                <div class="item-unit">
                    <form-group label="Unit">
                        <md-input
                            :disabled="!costLine.isBaseCharge"
                            :value="costLine.chargeUnit"
                            @input="onCostUnitInput($event)"
                        />
                        <div class="unit-charge-info" v-if="costLine.isBaseCharge && costLine.type === 'hourly'">Enter minutes eg. 65</div>
                    </form-group>
                </div>
                <div class="item-unitPriceExTax">
                    <form-group name="amount" label="Amount">
                        <md-input v-model.number="costLine.unitPriceExTax" />
                    </form-group>
                </div>
            </form-wrapper>
        </div>
        <div class="modal-footer">
            <md-button class="md-primary dialog-button" @click="addCostItem">
                Save
            </md-button>
            <md-button class="md-default dialog-button" @click.stop="closeCostItem">
                Cancel
            </md-button>
        </div>
    </div>
</template>

<script>
import { GeneralMixin } from '@/mixins/GeneralMixin';
import { required, decimal, requiredIf } from 'vuelidate/lib/validators';
import { handleRequests, showErrorMessage } from '@/helpers';

export default {
    name: 'TripCostItemModal',
    mixins: [GeneralMixin],
    props: {
        costLine: {
            type: Object,
            default: () => {}
        },
        tripId: {
            type: Number,
            default: null
        },
        resolve: {
            type: Function,
            default: () => {}
        },
        isManualCharge: {
            type: Boolean,
            default: false
        },
        manuallyChanged: {
            type: Boolean,
            default: false
        },
        userId: {
            type: Number,
            default: null
        }
    },
    validations: {
        costLine: {
            description: {
                required
            },
            quantity: {
                decimal
            },
            unitPriceExTax: {
                decimal
            }
        },
        costUnit: {
            decimal,
            required:
                // eslint-disable-next-line func-names
                requiredIf(function() {
                    return this.costUnitUpdated === true;
                })
        }
    },
    data() {
        return {
            description: '',
            unitPriceExTax: 0,
            quantity: 1,
            tempCostLine: null,
            costUnitUpdated: false,
            costUnit: null
        };
    },
    mounted() {
        this.tempCostLine = _.cloneDeep(this.costLine);
    },
    methods: {
        async addCostItem() {
            if (this.$v.$invalid) {
                showErrorMessage(this, 'Missing required data');
                return;
            }

            this.$_handleLoaderState(true, 'UPDATING...');
            const costUnitUpdatedOnly = this.tempCostLine.unitPriceExTax === this.costLine.unitPriceExTax && this.costUnitUpdated;

            const payload = {
                method: 'post',
                data: {
                    id: this.costLine.id,
                    description: this.costLine.description,
                    quantity: this.costLine.quantity,
                    unitPriceExTax: this.costLine.unitPriceExTax,
                    manuallyChanged: this.manuallyChanged && !costUnitUpdatedOnly,
                    isManualCharge: this.isManualCharge,
                    userId: this.userId,
                    chargeUnit: this.costUnit,
                    chargeUnitUpdated: costUnitUpdatedOnly
                }
            };
            try {
                const api = `/api/trips/${this.tripId}/rate/costs`;
                await handleRequests(api, payload);

                this.$notify({
                    message: `Cost added!`,
                    type: 'success'
                });
                this.$v.$reset();

                this.resolve(true);
            } catch (e) {
                const message = 'Cannot add cost.';
                showErrorMessage(this, message);
                this.resolve(false);
            }
            this.$_handleLoaderState(false);
        },
        closeCostItem() {
            Object.assign(this.costLine, this.tempCostLine);
            this.$modal.hide();
        },
        onCostUnitInput(input) {
            this.costUnitUpdated = true;
            this.costUnit = input;
        }
    }
};
</script>

<style lang="scss" scoped>
.unit-charge-info {
    font-size: small;
    color: darkgrey;
    font-weight: 400;
}
</style>